import createPlayerGraphNodeList from "../../lib/core/engine/PlayerGraphNode/createPlayerGraphNodeList"
import createSharedCachedFactory from "./createSharedCachedFactory"

export const usePlayerGraphList = createSharedCachedFactory(createPlayerGraphNodeList)